import { render, staticRenderFns } from "./AdditionalPrices.vue?vue&type=template&id=60f9dc59&scoped=true"
import script from "./AdditionalPrices.vue?vue&type=script&lang=ts"
export * from "./AdditionalPrices.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalPrices.vue?vue&type=style&index=0&id=60f9dc59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9dc59",
  null
  
)

export default component.exports